import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "text-grey line-through" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "clm-act-cntn" }
const _hoisted_9 = ["onClick"]

import { computed, getCurrentInstance, onMounted, ref, watch } from 'vue'
import Card from 'primevue/card'
import Paginator from '@/views/components/paginator/Paginator.vue'
import OverlayPanel from 'primevue/overlaypanel'
import ListActions from '@/views/components/list/ListActions.vue'
import HeaderCustom from '@/views/components/header/HeaderHjpTable.vue'
import DataTable from 'primevue/datatable'
import ProgressSpinner from 'primevue/progressspinner'
import EmptyState from '@/views/components/list/EmptyState.vue'
import Column from 'primevue/column'
import InputSwitch from 'primevue/inputswitch'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import { useStore } from 'vuex'
import numberFormat from '@/utils/helpers/numberFormat'
import HjpSideBar from '@/views/components/sidebar/HjpSideBar.vue'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import apiOpenUseCase from '@/usecase/apiOpenUseCase'
import HjpCofirmModal from '@/views/components/modal/HjpConfirmationModal.vue'
import changeImagePathPrefix from '@/utils/helpers/changeImagePathPrefix'
import environment from '@/configs/environtment'
import defaulListImage from '@/assets/img/icon/cross-black-background-grey.svg'
import Form from './forms/Form.vue'
import ManageStockForm from './forms/ManageStockForm.vue'
import HistoryStock from './forms/HistoryStock.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const snackEndpoint = '/ticket/v1/Snacks'
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const store = useStore()
const dataSource = ref([]) as any
const dataRow = ref()
const refOverlayAction = ref()
const emptyTable = ref('Data belum ada, silahkan tambah untuk mengisi data')
const headerTitle = ref('Master Snack')
const buttonTitle = ref('Tambah Snack')
const searchPlaceholder = ref('Cari Disini...')
const formIndex = ref(0)
const showFormPanel = computed({
  get: () => store.state.hjpDataList.modalForm.show,
  set: (value) => {
    store.dispatch('setShowModalFormDl', value)
  }
})

const filters = ref({
  search: '',
  filterField: ['q'],
  pageNumber: 1,
  pageSize: 10,
  totalRecords: 1,
  custom: [] as any
})

const confirmDialogDeleteAttr = ref({
  show: false,
  title: 'Hapus Snack?',
  subTitle: 'Data stok dan snack tersebut akan dihapus dalam sistem. Yakin hapus snack?',
  btnSubmitTitle: 'Hapus Snack',
  imgContent: require('@/assets/img/modal-confirmation/delete-default.svg')
})

const showDropDown = (evt: any, item: any) => {
  dataRow.value = item
  formIndex.value = 0
  refOverlayAction.value.toggle(evt)
}

const onChangePage = (event: any) => {
  console.log('changePage', event)
  filters.value.pageNumber = event.page + 1
  // eslint-disable-next-line no-use-before-define
  getAllData()
}

const changeIsActive = async (val: any) => {
  console.log('val', val)
  store.dispatch('showLoading')
  const payload = { IsActive: val.IsActive }
  await apiOpenUseCase.patchWithNoId(`${snackEndpoint}/${val.Id}/Activate`, payload).then((response) => {
    const { error, message } = response
    if (!error) {
      $toast.add({
        severity: 'success',
        detail: 'Data Snack Berhasil Dinonaktifkan',
        group: 'bc',
        closable: false,
        life: 3000
      })
      // eslint-disable-next-line no-use-before-define
      getAllData()
    } else {
      $toast.add({
        severity: 'error',
        summary: 'Gagal menonaktifkan Snack',
        detail: message,
        group: 'bc',
        closable: false,
        life: 3000
      })
      val.IsActive = !val.IsActive
    }
  })
  store.dispatch('hideLoading')
}

const onDelete = () => {
  console.log('delete', dataRow.value)
  // eslint-disable-next-line no-use-before-define
  showDialogDeleteConfirmation()
}

const onClickBtnAdd = () => {
  console.log('add')
  formIndex.value = 0
  // eslint-disable-next-line no-use-before-define
  showForm()
}

const onSearch = (val: any) => {
  console.log('search', val)
  filters.value.search = val
  filters.value.pageNumber = 1
  // eslint-disable-next-line no-use-before-define
  getAllData()
}

const onSort = (event: any) => {
  console.log('sort', event)
  filters.value.custom = [['OrderBy', '=', `${event.sortField} ${event.sortOrder === 1 ? 'asc' : 'desc'}`]]
  filters.value.pageNumber = 1
  // eslint-disable-next-line no-use-before-define
  getAllData()
}

const hideFormPanel = () => {
  showFormPanel.value = false
  store.dispatch('storeRowDataTable', null)
}

const setDataRowOnRedux = () => {
  console.log('dataRow', dataRow.value)
  store.dispatch('storeRowDataTable', dataRow.value)
}

const showForm = () => {
  console.log('showForm')
  showFormPanel.value = true
}

const onEdit = () => {
  console.log('edit', dataRow.value)
  formIndex.value = 0
  setDataRowOnRedux()
  showForm()
}

const getAllData = async () => {
  store.dispatch('showLoading')
  await apiOpenUseCase.get(`${snackEndpoint}${returnUrlPrams(filters.value)}`).then((response) => {
    // console.log('get', response)
    const { error, result, count } = response
    if (!error) {
      dataSource.value = result.map((data: any) => ({
        ...data,
        ImageOrigin: data.Image ?? null,
        Image: data.Image ? `${environment.getApiImageBaseUrl()}${changeImagePathPrefix(data.Image)}` : null,
        PriceAfterDiscount: data.Discount ? data.Price - (data.Price * (data.Discount / 100)) : data.Price,
        CondecturCommission: data.ActivePrice.PriceCommisions.find((item: any) => item.SnackSalesChannel === 'Conductor')?.CommissionValue ?? 0,
        NonCondecturCommission: data.ActivePrice.PriceCommisions.find((item: any) => item.SnackSalesChannel === 'MobileApp')?.CommissionValue ?? 0,
        IsShowHJKru: data.SnackChannels.find((item: any) => item.SalesChannel === 'Conductor')?.IsActive ?? false,
        IsShowHJApps: data.SnackChannels.find((item: any) => item.SalesChannel === 'MobileApp')?.IsActive ?? false,
      }))
      filters.value.totalRecords = count
      console.log('dataSource', dataSource.value)
    }
  })
  store.dispatch('hideLoading')
}

const showDialogDeleteConfirmation = () => {
  confirmDialogDeleteAttr.value.show = true
}

const hideDialogDeleteConfirmation = () => {
  confirmDialogDeleteAttr.value.show = false
  store.dispatch('storeRowDataTable', dataRow.value)
  dataRow.value = null
}

const onSubmitDeleteConfirmation = async () => {
  store.dispatch('showLoading')
  try {
    await apiOpenUseCase.delete(`${snackEndpoint}`, dataRow.value.Id).then((response) => {
      const { error, message } = response
      if (!error) {
        $toast.add({
          severity: 'success',
          detail: 'Data Snack Berhasil Dihapus',
          group: 'bc',
          closable: false,
          life: 3000
        })
        hideDialogDeleteConfirmation()
        getAllData()
      } else {
        $toast.add({
          severity: 'error',
          summary: 'Gagal menghapus Snack',
          detail: message,
          group: 'bc',
          closable: false,
          life: 3000
        })
      }
    })
  } catch (error) {
    console.log('err', error)
  }
  store.dispatch('hideLoading')
}

const onEditSnackStock = () => {
  console.log('editStock')
  formIndex.value = 1
  setDataRowOnRedux()
  showForm()
}

const onViewSnackStockHistory = () => {
  console.log('viewSnackStockHistory')
  formIndex.value = 2
  setDataRowOnRedux()
  showForm()
}

watch(() => store.getters.reloadTable, (val) => {
  if (val) {
    getAllData()
  }
})

onMounted(() => {
  getAllData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(HeaderCustom, {
            titleHeader: headerTitle.value,
            titleButton: buttonTitle.value,
            onRedirectAdd: onClickBtnAdd,
            placeholder: searchPlaceholder.value,
            onOnSearch: onSearch
          }, null, 8, ["titleHeader", "titleButton", "placeholder"])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_unref(DataTable), {
          id: "hjp-data-table",
          value: _unref(dataSource),
          paginator: false,
          class: "table-og hjp-data-table",
          responsiveLayout: "scroll",
          lazy: true,
          onSort: onSort
        }, {
          empty: _withCtx(() => [
            _createVNode(EmptyState, { textNoData: emptyTable.value }, null, 8, ["textNoData"])
          ]),
          loading: _withCtx(() => [
            _createVNode(_unref(ProgressSpinner), { style: {"width":"70px","height":"70px"} })
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(Column), { header: "Thumbnail" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("img", {
                  src: slotProps.data.Image ?? _unref(defaulListImage),
                  class: "rounded-lg",
                  style: _normalizeStyle(slotProps.data.Image ? 'width: 100px;' : 'width: 50px;'),
                  alt: "SnackThumbnail"
                }, null, 12, _hoisted_2)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              header: "Nama Snack",
              field: "name",
              sortable: ""
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.Name), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              header: "Harga",
              field: "price",
              sortable: ""
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.Discount > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(rupiahFormat)(slotProps.data.Price)), 1),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(rupiahFormat)(slotProps.data.PriceAfterDiscount)), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", null, _toDisplayString(_unref(rupiahFormat)(slotProps.data.Price)), 1)
                    ]))
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              header: "Diskon",
              field: "discount",
              sortable: ""
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(`${_unref(numberFormat)(slotProps.data.Discount)}%`), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              header: "Stok",
              field: "StockCumulative",
              sortable: ""
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_unref(numberFormat)(slotProps.data.StockCumulative)), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Aktif" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_unref(InputSwitch), {
                    modelValue: slotProps.data.IsActive,
                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.IsActive) = $event),
                    onChange: ($event: any) => (changeIsActive(slotProps.data))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              class: "colom-action mx-auto",
              header: "Aksi"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("i", {
                    class: "pi pi-ellipsis-h text-base cursor-pointer color-dark",
                    onClick: ($event: any) => (showDropDown($event, slotProps.data))
                  }, null, 8, _hoisted_9)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_unref(OverlayPanel), {
          ref_key: "refOverlayAction",
          ref: refOverlayAction
        }, {
          default: _withCtx(() => [
            _createVNode(ListActions, {
              edit: true,
              del: true,
              editSnackStock: true,
              viewSnackStockHistory: true,
              editTitle: 'Edit Snack',
              delTitle: 'Hapus',
              editSnackStockTitle: 'Kelola Stok',
              viewSnackStockHistoryTitle: 'Riwayat Stok',
              onDel: onDelete,
              onEdit: onEdit,
              onEditSnackStock: onEditSnackStock,
              onViewSnackStockHistory: onViewSnackStockHistory
            })
          ]),
          _: 1
        }, 512)
      ]),
      footer: _withCtx(() => [
        (filters.value.totalRecords > 0)
          ? (_openBlock(), _createBlock(Paginator, {
              key: 0,
              rows: filters.value.pageSize,
              totalRecords: filters.value.totalRecords,
              onOnPage: onChangePage
            }, null, 8, ["rows", "totalRecords"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(HjpSideBar, {
      show: _unref(showFormPanel),
      onHideDialog: hideFormPanel,
      canDelete: false
    }, _createSlots({ _: 2 }, [
      (_unref(showFormPanel))
        ? {
            name: "form",
            fn: _withCtx(() => [
              (formIndex.value === 1)
                ? (_openBlock(), _createBlock(ManageStockForm, { key: 0 }))
                : (formIndex.value === 2)
                  ? (_openBlock(), _createBlock(HistoryStock, { key: 1 }))
                  : (_openBlock(), _createBlock(Form, { key: 2 }))
            ])
          }
        : undefined
    ]), 1032, ["show"]),
    _createVNode(HjpCofirmModal, {
      show: confirmDialogDeleteAttr.value.show,
      imgContent: confirmDialogDeleteAttr.value.imgContent,
      title: confirmDialogDeleteAttr.value.title,
      subTitle: confirmDialogDeleteAttr.value.subTitle,
      btnSubmitTitle: confirmDialogDeleteAttr.value.btnSubmitTitle,
      onHideDialog: hideDialogDeleteConfirmation,
      onOnSubmit: onSubmitDeleteConfirmation
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle"])
  ]))
}
}

})